import React from "react";
import { useAppStore } from "../store/useAppStore";

const Sidebar = ({ mobileOpen, onMobileClose }) => {
  const user = useAppStore((state) => state.user);
  const logout = useAppStore((state) => state.logout);
  const activePage = useAppStore((state) => state.activePage);
  const setActivePage = useAppStore((state) => state.setActivePage);
  const visualPreset = useAppStore((state) => state.visualPreset);
  const toggleVisualPreset = useAppStore((state) => state.toggleVisualPreset);

  const handleNavClick = (page) => {
    setActivePage(page);
    if (onMobileClose) onMobileClose();
  };

  return (
    <aside className={mobileOpen ? "sidebar-open" : ""}>
      <div className="aside-logo">
        <i className="fa-solid fa-hands" aria-hidden="true"></i> Lapse
      </div>

      <nav className="aside-menu">
        <button
          className={`aside-link ${activePage === "home" ? "active" : ""}`}
          type="button"
          onClick={() => handleNavClick("home")}
        >
          <i className="fa-solid fa-house" aria-hidden="true"></i>
          Главная
        </button>
        <button
          className={`aside-link ${activePage === "requests" ? "active" : ""}`}
          type="button"
          onClick={() => handleNavClick("requests")}
        >
          <i className="fa-solid fa-clipboard-list" aria-hidden="true"></i>
          Заявки
        </button>
        <button
          className={`aside-link ${activePage === "gestures" ? "active" : ""}`}
          type="button"
          onClick={() => handleNavClick("gestures")}
        >
          <i className="fa-solid fa-hands" aria-hidden="true"></i>
          Жесты
        </button>
        <button
          className={`aside-link ${activePage === "sentences" ? "active" : ""}`}
          type="button"
          onClick={() => handleNavClick("sentences")}
        >
          <i className="fa-solid fa-quote-right" aria-hidden="true"></i>
          Предложения
        </button>
        <button
          className={`aside-link ${activePage === "translation" ? "active" : ""}`}
          type="button"
          onClick={() => handleNavClick("translation")}
        >
          <i className="fa-solid fa-language" aria-hidden="true"></i>
          Перевод
        </button>
      </nav>

      <div className="aside-user">
        <i className="fa-regular fa-circle-user" aria-hidden="true"></i>
        <div>
          {user?.username || user?.email || "Пользователь"}
          <span>{user?.email || ""}</span>
        </div>
      </div>

      <button className="e-btn aside-logout" type="button" onClick={logout}>
        <i className="fa-solid fa-right-from-bracket" aria-hidden="true"></i>
        Выйти
      </button>

      <button className="e-btn aside-theme" type="button" onClick={toggleVisualPreset}>
        <i className="fa-solid fa-palette" aria-hidden="true"></i>
        {visualPreset === "glass-cold" ? "Glass: Cold" : "Glass: Default"}
      </button>
    </aside>
  );
};

export default Sidebar;
